import './App.css'
import React from 'react'
import { Router } from 'react-router-dom'
import AppContext from './AppContext'
import AppSetup from './AppSetup'
import Routes, { history } from './Router'
import { BugsnagErrorBoundary } from './libs/bugSnag'

export default () => {
  return (
    <BugsnagErrorBoundary>
      <AppContext>
        <AppSetup>
          <Router history={history}>
            <Routes />
          </Router>
        </AppSetup>
      </AppContext>
    </BugsnagErrorBoundary>
  )
}
